export enum SettingsRoutesEnum {
  LIST = '',
}
